// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200536/js/" + chunkId + "." + {"44":"0ec20188","225":"b196d535","481":"8f32b1e8","486":"b7e2b290","770":"5e5ed0b6"}[chunkId] + ".0.3488610251312805.chunk.js";
};